import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import _ from 'lodash';
//import { ExcelColumn } from './../../shared/service-proxies/service-proxies';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';

@Injectable({
  providedIn: 'root'
})
export class ExcelService {

  constructor() { }

  public exportAsExcelFile(json: any[], excelFileName: string, columns: any): void {
   
    var data = JSON.stringify(json) ;
    var lastData : any = json ;

    if (columns != null){
      //Excel'e yazarken kullanilacak sutun basliklari ayarlaniyor.
        //Bu method ayri bir sinif icine cagrilarak kullanilacak.
        _.forEach(columns, function(d, key) {
          data = data.split('\"'+ d.name +'\":').join('\"' + d.asName + '\":');
        });
        
        lastData = JSON.parse(data);
    }

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(lastData);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }

  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION);
  }
}


